var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-con"},[_c('Card',{attrs:{"icon":"log-in","title":"绘天才后台管理系统","bordered":false}},[_c('div',{staticClass:"form-con"},[_c('login-form',{on:{"on-success-valid":_vm.handleSubmit}})],1),_c('div',{staticClass:"support"},[_vm._v("技术支持： 西安牛二网络科技有限公司")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }